import { OutcomePublic } from '#models/outcome';
import { Dictionary } from '#models/questionnaire';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Questionnaire } from './Questionnaire';

export interface QuestionnairePreviewProps {
  callBackParent?: (id: string, outcome: OutcomePublic) => void;
  getDataQuestionnaire?: (data: any) => void;
  appImages: Dictionary;
  resetQuestionnaire?: boolean;
  isMapEnabled: boolean;
  googleKey: string;
  PTID?: string;
  hasLocalStorage?: boolean;
  currency: { name: string; symbol: string };
  isWhiteLabel: boolean;
  defaultPicture: string;
  getDataOutcome: (data: OutcomePublic | null) => void;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10_000
    }
  }
});

export const QuestionnairePreview = ({
  callBackParent,
  appImages,
  resetQuestionnaire = false,
  getDataQuestionnaire,
  isMapEnabled,
  googleKey,
  isWhiteLabel,
  PTID,
  hasLocalStorage,
  currency,
  defaultPicture,
  getDataOutcome
}: QuestionnairePreviewProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Questionnaire
        callBackParent={callBackParent}
        appImages={appImages}
        resetQuestionnaire={resetQuestionnaire}
        getDataQuestionnaire={getDataQuestionnaire}
        isMapEnabled={isMapEnabled}
        googleKey={googleKey}
        isWhiteLabel={isWhiteLabel}
        PTID={PTID}
        hasLocalStorage={hasLocalStorage}
        currency={currency}
        defaultPicture={defaultPicture}
        getDataOutcome={getDataOutcome}
      />
      <ToastContainer hideProgressBar />
    </QueryClientProvider>
  );
};
